var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"box box-bg",class:{
    'box-outlined': _vm.outlined,
    'box-filled': !_vm.outlined,
    'box-max_height': !!_vm.maxHeight,
    'box-active': _vm.isActive,
    'box-disabled': _vm.isDisabled,
  },style:({ maxHeight: _vm.maxHeight, height: _vm.height })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }